import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { IPessoa } from '../index';

interface ContratanteTabProps {
  contratante: IPessoa;
  setContratante: React.Dispatch<React.SetStateAction<IPessoa>>;
}

const formatPhone = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 10) {
    return digits.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d{1,4})$/, '$1-$2');
  }
  return digits.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d{1,4})$/, '$1-$2');
};

const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const ContratanteTab: React.FC<ContratanteTabProps> = ({ contratante, setContratante }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name === 'telefone') {
      setContratante(prev => ({ ...prev, telefone: formatPhone(value) }));
    } else {
      setContratante(prev => ({ ...prev, [name]: value }));
    }
  };

  const emailInvalid = !!contratante.email && !isValidEmail(contratante.email);

  return (
    <Form>
      <p className="text-muted mb-4">Responsável interno pela gestão do contrato.</p>
      <Row className="g-3">
        <Col md={12}>
          <Form.Group controlId="contratanteNome">
            <Form.Label>Nome</Form.Label>
            <Form.Control
              type="text"
              name="nome"
              value={contratante.nome}
              onChange={handleChange}
              placeholder="Nome completo"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="contratanteEmail">
            <Form.Label>E-mail</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={contratante.email}
              onChange={handleChange}
              placeholder="email@empresa.com.br"
              isInvalid={emailInvalid}
            />
            <Form.Control.Feedback type="invalid">E-mail inválido.</Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="contratanteTelefone">
            <Form.Label>Telefone</Form.Label>
            <Form.Control
              type="tel"
              name="telefone"
              value={contratante.telefone}
              onChange={handleChange}
              placeholder="(00) 00000-0000"
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

export default ContratanteTab;
